import linkTypeSelectors from './linkTypeSelectors';

export default (element) => {
	let linkType;

	if (element instanceof Element) {
		// iterate through link types to test element against
		Object.entries(linkTypeSelectors).forEach(([type, selectors]) => {
			if (
				!linkType &&
				selectors.find((selector) => element.matches(selector))
			) {
				linkType = type;
			}
		});
	}

	return linkType || 'generic';
};
